import App from '../components/App';
import Order from '../components/Order';
import About from '../components/About';
import Classes from '../components/Classes';
import { createBrowserRouter } from 'react-router-dom';
import Menu from '../components/Menu';
// import MonthlyPickups from '../components/MonthlyPickups'

export const router = createBrowserRouter(
    [
      {
        path: '/',
        element: <App/>
      },
      {
        path: 'order',
        element: <Order />
      },
      {
        path: 'about',
        element: <About />
      },
      {
        path: 'classes',
        element: <Classes />
      },
      {
        path: 'menu',
        element: <Menu />
      },
      // {
      //   path: 'monthly-pickups',
      //   element: <MonthlyPickups/>
      // }
    ]
  )